import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

// Basic Dialog box with dynamic button amount.
// Input properties:
// open: Type bool. Defines whether the dialog is open or closed.
// title: Type String. Defines the title of the dialog box.
// content: Type Sting. Defines the body of the dialog box.
// buttons: Type Buttons. Can handle multiple buttons. Styles must be set on the
//          input buttons
/**

  * @property {object} styles style for the DrcKeyValueTable

 */
var styles = (theme) => ({
    key: {
        textAlign: 'right',
        fontWeight: 'bold',
        padding: '4px'
    },
    tooltip: {
        fontSize: '1rem'
    }
});

/**
 * @description The DrcKeyValueTable is a customizable table with a tooltip on the value, easy way to display a list of key value data which is to be sent in an array of Objects as child to the component
 * (children=[{key:"color",value:"red"},{key:"weight":"01"}])
 * @author stephen.weessies
 * @class DrcKeyValueTable
 * @example
 *<DrcKeyValueTable>[{key:"color",value:"red"},{key:"weight":"01"}]</DrcKeyValueTable>
 * @category Tables
 * @tags label key value pair list table data
 * @property {Array} children data array to be displayed in a key value table
 * @property {Object} ClassName Classes for styling the table
 * @extends {React.Component} */

class DrcKeyValueTable extends React.Component {
    /**
     * Creates an instance of DrcKeyValueTable.
     * @memberof DrcKeyValueTable
     * @return {*}
     *
     */
    renderRow = (row) => {
        var { classes } = this.props;

        return (
            <tr key={row.key}>
                <td className={classes.key}>{row.key} : </td>
                <td>
                    {row.tooltip ? (
                        <Tooltip title={row.tooltip ? <React.Fragment>{row.tooltip} </React.Fragment> : null} className={classes.tooltip}>
                            <Typography style={{ cursor: 'auto' }}>{row.value}</Typography>
                        </Tooltip>
                    ) : (
                        <Typography>{row.value}</Typography>
                    )}
                </td>
            </tr>
        );
    };
    /**
     *
     *
     * @return {*}
     * @memberof DrcKeyValueTable
     */
    render() {
        const { children, className } = this.props;

        return (
            <table className={className}>
                <tbody>{(children || []).map((row) => this.renderRow(row))}</tbody>
            </table>
        );
    }
}

export default withStyles(styles)(DrcKeyValueTable);
